//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { isUndefined } from '@utils/filterPredicates';

export const getPinterestUser = createSelector(
  (state: ICuralateStore) => state.pinterest,
  (pinterest) => pinterest.user,
);

export const getIsPinterestBusinessAccount = createSelector(
  getPinterestUser,
  (user) => user.user?.isPartner,
);

export const getPinterestUserBoards = createSelector(
  getPinterestUser,
  (user) => user.boards,
);

export const getPinterestUserFlags = createSelector(
  getPinterestUser,
  (user) => user.flags,
);

export const getPinterestUserErrors = createSelector(
  getPinterestUser,
  (user) => user.errors,
);

export const getPinterestHasFetchedUser = createSelector(
  getPinterestUser,
  getPinterestUserFlags,
  getPinterestUserErrors,
  ({ user }, { isFetchingUser }, { fetchUserError }) =>
    !isFetchingUser && !(isUndefined(user) && isUndefined(fetchUserError)),
);
